import { RouteFrameCode } from 'components/common/types/Deal.types';
import { FileList, FileContent } from 'components/common/types';

export const isFrameFromUploadedFile = (
  code: string,
  uploadedFiles: FileList[],
  environmentId: string,
  mediaOwner?: string,
): boolean => {
  return uploadedFiles.some(({ fileContents = [] }) => {
    return fileContents.some(
      (frameContent) => frameContent.code === code && (frameContent.mediaOwner || environmentId) === mediaOwner,
    );
  });
};

export const getManuallySelectedFrames = (
  selectedFrames: RouteFrameCode[],
  uploadedFiles: FileList[],
  environmentId: string,
): RouteFrameCode[] => {
  return selectedFrames.filter(
    (frame) => !isFrameFromUploadedFile(frame.code, uploadedFiles, environmentId, frame.mediaOwner),
  );
};

export const isFrameExcludedFromFile = (fileName: string, frameCode: string, uploadedFiles: FileList[]): boolean => {
  const file = uploadedFiles.find(({ name }) => name === fileName);
  return file?.excludedFrameCodes?.includes(frameCode) ?? false;
};

export const updateFileIncludeStatus = (
  files: FileList[],
  targetFile: FileList,
  shouldInclude: boolean,
): FileList[] => {
  return files.map((file) => {
    if (file.name === targetFile.name) {
      return { ...file, include: shouldInclude, excludedFrameCodes: [] };
    }
    return file;
  });
};

export const toggleFrameInFileExclusionList = (
  files: FileList[],
  fileName: string,
  frameCode: string,
  isCurrentlyExcluded: boolean,
): FileList[] => {
  return files.map((file) => {
    if (file.name === fileName) {
      const excludedFrameCodes = file.excludedFrameCodes || [];

      if (isCurrentlyExcluded) {
        return {
          ...file,
          include: true,
          excludedFrameCodes: excludedFrameCodes.filter((code) => code !== frameCode),
        };
      }

      return {
        ...file,
        include: true,
        excludedFrameCodes: [...excludedFrameCodes, frameCode],
      };
    }

    return file;
  });
};

export const calculateFileInclusionState = (
  file: FileList,
): {
  fileFrames: FileContent[];
  excludedFrames: string[];
  isFileIncluded: boolean;
  hasExcludedFrames: boolean;
  allFramesIncluded: boolean;
  someFramesIncluded: boolean;
} => {
  const fileFrames = file.fileContents || [];
  const excludedFrames = file.excludedFrameCodes || [];

  const isFileIncluded = file.include !== false;
  const hasExcludedFrames = excludedFrames.length > 0;
  const allFramesIncluded = isFileIncluded && !hasExcludedFrames;
  const someFramesIncluded = isFileIncluded && hasExcludedFrames && excludedFrames.length < fileFrames.length;

  return {
    fileFrames,
    excludedFrames,
    isFileIncluded,
    hasExcludedFrames,
    allFramesIncluded,
    someFramesIncluded,
  };
};
